import React from "react";
import { Link } from "react-router-dom";
import { Home, AlertTriangle } from "lucide-react";

const NotFound = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 p-4 text-center">

      <div style={{ animation: "bounceIn 0.6s ease both" }}>
        <div className="w-24 h-24 bg-red-50 rounded-full flex items-center justify-center mx-auto mb-6">
          <AlertTriangle size={44} className="text-danger" />
        </div>
      </div>

      <h1
        className="text-7xl font-bold text-danger mb-2"
        style={{ animation: "slideUp 0.5s ease 0.15s both", opacity: 0 }}
      >
        404
      </h1>

      <p
        className="text-lg text-gray-500 mb-8"
        style={{ animation: "slideUp 0.5s ease 0.25s both", opacity: 0 }}
      >
        Oops — this page doesn't exist.
      </p>

      <Link
        to="/"
        className="bg-primary text-white px-6 py-3 rounded-xl hover:bg-blue-800 active:scale-95 transition-all duration-200 shadow-md hover:shadow-lg flex items-center gap-2 text-sm font-medium"
        style={{ animation: "slideUp 0.5s ease 0.35s both", opacity: 0 }}
      >
        <Home size={16} /> Go Home
      </Link>

      <style>{`
        @keyframes slideUp {
          from { opacity: 0; transform: translateY(20px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @keyframes bounceIn {
          0%   { opacity: 0; transform: scale(0.5); }
          70%  { transform: scale(1.1); }
          100% { opacity: 1; transform: scale(1); }
        }
      `}</style>
    </div>
  );
};

export default NotFound;